"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function regionFromLocale(locale) {
  var code = locale.split('-')[1];
  return code && code.toUpperCase();
}

exports.regionFromLocale = regionFromLocale;

function languageFromLocale(locale) {
  return locale.split('-')[0].toLowerCase();
}

exports.languageFromLocale = languageFromLocale;